import React from 'react';
import { Modal, ModalFooter, Rating } from 'fronton-react';
import cn from 'clsx';
import { EffectFade, Pagination } from 'swiper/modules';
import { createElementKey } from 'utils';
import { fullWidthMobileButton } from '../../../../styles/common';
import { ButtonWithGAClickButton } from '../../../button';
import { getImageSrc } from '../../../picture';
import { Thumbs, Swiper, SwiperClass, SwiperSlide } from '../../../swiper';
import { Typography } from '../../../typography';
import {
  reviewsCatalogItemAddWrapper,
  reviewsCatalogModal,
  reviewsCatalogModalContent,
  reviewsCatalogImageBig,
  reviewsCatalogSlideThumb,
  reviewsCatalogImageSwiperBig,
  reviewsCatalogImageSwiperSmall,
  reviewsCatalogImageThumb,
  reviewsCatalogModalText,
  reviewsCatalogModalRatingWrapper,
  reviewsCatalogModalTextWrapper,
  reviewsCatalogModalRatingText,
  reviewsCatalogModalAddDataWrapper,
  reviewsCatalogModalContentWrapper,
  reviewsCatalogModalFooter,
} from './review-catalog-modal-b-styles';

type ReviewStructure = {
  imagesAlt: string;
  images: string[];
  bigImages: string[];
  rating: number;
  text: string;
  date: string;
  store?: string;
};

type ReviewsCatalogModalProps = {
  activeReview: ReviewStructure;
  isOpen: boolean;
  modalButton: React.ReactNode;
  onClose: () => void;
  setThumbsSwiper: (thumbSwiper: SwiperClass | null) => void;
  thumbsSwiper: SwiperClass | null;
}

export const ReviewSignUpButton: React.FC<{ elementBlcok: string; signUpHref: string }> = ({ elementBlcok, signUpHref }) => (
  <ButtonWithGAClickButton
    className={fullWidthMobileButton}
    elementBlock={`${elementBlcok} / Reviews`}
    elementName="Отзывы клиентов / modal"
    elementText="Записаться на проектирование"
    title="Запишитесь на проектирование"
    href={signUpHref}
    target="_blank"
    variant="accent"
    wide
  >
    Записаться на проектирование
  </ButtonWithGAClickButton>
);

export const ReviewsCatalogModalB: React.FC<ReviewsCatalogModalProps> = ({
  activeReview, modalButton, isOpen, onClose, setThumbsSwiper, thumbsSwiper,
}) => (
  <Modal className={reviewsCatalogModal} onClose={onClose} show={isOpen}>
    <div
      className={cn(reviewsCatalogModalContentWrapper, reviewsCatalogModalContent)}
    >
      <Swiper
        breakpoints={{
          768: { pagination: { enabled: false } },
        }}
        className={reviewsCatalogImageSwiperBig}
        modules={[EffectFade, Thumbs, Pagination]}
        pagination={{
          clickable: false,
        }}
        thumbs={{ swiper: thumbsSwiper }}
        effect="fade">
        {activeReview.bigImages.map((image, index) => (
          <SwiperSlide key={createElementKey('review-modal-photo', index)}>
            <img
              className={reviewsCatalogImageBig}
              alt={activeReview.imagesAlt}
              src={getImageSrc(image)}
              width="700"
              height="440"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={reviewsCatalogModalTextWrapper}>
        <div className={reviewsCatalogModalAddDataWrapper}>
          <div className={reviewsCatalogModalRatingWrapper}>
            <Rating value={activeReview.rating} size="l" />
            <Typography
              className={reviewsCatalogModalRatingText}
              variant="caption"
              color="success-primary">
              Рекомендую
            </Typography>
          </div>
          <div className={reviewsCatalogItemAddWrapper}>
            <Typography variant="caption" color="text-minor">
              {activeReview.date}
            </Typography>
            {activeReview.store && (
              <Typography variant="caption" color="text-minor">
                {activeReview.store}
              </Typography>
            )}
          </div>
        </div>
        <Typography className={reviewsCatalogModalText} variant="l" size="body_long">
          {activeReview.text}
        </Typography>
      </div>
    </div>

    <ModalFooter className={cn(reviewsCatalogModalContentWrapper, reviewsCatalogModalFooter)}>
      <Swiper
        className={reviewsCatalogImageSwiperSmall}
        modules={[Thumbs]}
        onSwiper={setThumbsSwiper}
        slidesPerView="auto"
        watchOverflow
      >
        {activeReview.bigImages.map((image, index) => (
          <SwiperSlide
            className={reviewsCatalogSlideThumb}
            key={createElementKey('review-modal-thumb-photo', index)}>
            <img
              className={reviewsCatalogImageThumb}
              alt={activeReview.imagesAlt}
              src={getImageSrc(image, { width: 32, height: 32, objectFit: 'fill' }, true)}
              width="32"
              height="32"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {modalButton}
    </ModalFooter>
  </Modal>
);
